<div class="most-visited">
  <div>{{ 'FLEX_HOME.HOME.MOST_VISITED.TITLE' | translate }}</div>
  @for (button of mostVisitedButtons(); track $index) {
    <dsy-button
      variant="secondary"
      [iconSide]="'right'"
      [iconName]="'chevron_right'"
      [iconLibrary]="'material'"
      [iconSize]="'1rem'"
      button-style="text-decoration: none; padding: 0.45rem 0.7rem; border-radius: 0.25rem;"
      (click)="openLink(button.url, button.mixPanelEvent)"
    >
      <span class="most-visited__button-text">
        {{ button.label | translate }}
      </span>
    </dsy-button>
  }
</div>
